import { tvpil } from '../../data/compat/tvpil';

export const phoenixConfig = {
  get apiVersion() {
    return tvpil.appStore.dms.apiVersion;
  },
  get timeout() {
    return tvpil.appStore.dms.serverTimeOut * 1000;
  },
  get baseUrl() {
    return tvpil.appStore.dms.endpointUrl + '/api_v3/service';
  },
  get clientTag() {
    return tvpil.appStore.params.dmsSetting.clientTag;
  },
  get language() {
    return tvpil.appStore.localizationStore.appLanguage;
  },
  get assetsMediaTypes() {
    return tvpil.appStore.dms.mediaTypes;
  },
  /**
   * @see https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/3382772526/device+Brand+Ids+family+List
   */
  get deviceFamilyId() {
    return tvpil.appStore.dms.deviceFamilyId;
  },
  get graphQlUrl() {
    return tvpil.appStore.dms.graphQlUrl;
  },
};
